import Embed from './embed';

class ScrollytellingImageEmbed extends Embed {
  static create(value) {
    const domNode = super.create({
      ...value,
      label: this.label(value),
      customTitle: this.title(value),
      iconName: 'video_library',
      iconClass: '',
      image: value.src,
      buttons: ['edit'],
    });

    domNode.insertAdjacentHTML('beforeend', this.html(value));

    return domNode;
  }

  static label({
    type = ScrollytellingImageEmbed.TYPE.INTERNAL,
  }) {
    if (type === ScrollytellingImageEmbed.TYPE.EXTERNAL) {
      return 'scrollytellingExternalImage';
    }
    if (type === ScrollytellingImageEmbed.TYPE.COLLECTION) {
      return 'scrollytellingCollectionImage';
    }
    return 'scrollytellingImage';
  }

  static title({
    caption = '',
    alt = '',
    title = '',
  }) {
    return `${title} - ${[caption, alt].filter(Boolean).join(' / ')}`;
  }

  static html() {
    return '';
  }

  static value(domNode) {
    const data = domNode.dataset;
    const value = {
      type: data.embedType,
      caption: data.embedCaption,
      alt: data.embedAlt,
      src: data.embedSrc,
    };

    if (data.embedType === ScrollytellingImageEmbed.TYPE.INTERNAL) {
      value.clippingId = data.embedClippingId;
      value.mobileClippingId = data.embedMobileClippingId;
    }
    if (data.embedType === ScrollytellingImageEmbed.TYPE.COLLECTION) {
      value.fileId = data.embedFileId;
      value.fileSrc = data.embedFileSrc;
      value.mobileFileId = data.embedMobileFileId;
      value.mobileFileSrc = data.embedMobileFileSrc;
    }
    return value;
  }

  /**
   * Types of embeded images.
   * @return {{EXTERNAL: string, INTERNAL: string, COLLECTION: string,}}
   */
  // Esto deberian ser los attributos del blot
  // que se representaria con la función estática
  // formats(domNode)
  static get TYPE() {
    return {
      EXTERNAL: 'external-image',
      INTERNAL: 'internal-image',
      COLLECTION: 'collections-image',
    };
  }
}

ScrollytellingImageEmbed.blotName = 'scrollytellingImageEmbed';
ScrollytellingImageEmbed.className = 'ql-scrollytelling-image';
ScrollytellingImageEmbed.tagName = 'div';

export default ScrollytellingImageEmbed;
